module.exports = flarum.core.compat['common/Application'];